import { ReactElement } from "react";

import LoadingComponent from "../components/LoadingIndicators/LoadingComponent";
import { SYSTEM_MAINTENANCE_PATH } from "../constants";
import useFeatureFlag from "../hooks/useFeatureFlag";

const RedirectToMaintenance = ({ children }: { children: ReactElement }): ReactElement => {
  const isSystemMaintenanceOn = useFeatureFlag("ALL_ENABLE_MAINTENANCE_PAGE");

  if (isSystemMaintenanceOn) {
    window.location.replace(SYSTEM_MAINTENANCE_PATH);

    return <LoadingComponent title={"Redirecting"} />;
  }

  return children;
};

export default RedirectToMaintenance;
